
import React from 'react'
import LayoutNode, { getNodeComponentAttributeValue, getNodeRootStyleAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { GetWBComponentByTypename  } from "./Data/WBData";
import { wBComponentTypeNames } from 'vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames';
import WebDesigner from './WebDesigner';
import { CSSClassNames } from './CSSClassNameConstants';
import { attributeTypes, componentAttributeTypes } from 'vagaro-website-rendering/src/components/Definitions/AttributeTypes';

import HoverToolTip from './HoverToolTip';

export default function HierarchyBrowser({rootNode,designer}:{rootNode:LayoutNode,designer:WebDesigner}) {


 

    const RenderNodeRecursive = ({node,depth}:{node:LayoutNode,depth:number})=>{

        const comp = GetWBComponentByTypename(node.typename);
        const isRoot = wBComponentTypeNames.pageRoot == node.typename;

        let name = comp.displayName;
        if(node.typename == wBComponentTypeNames.section){
            const tag = getNodeComponentAttributeValue(node,"tag","");
            if(tag!=""){
                name += " ("+tag+")";
            }
        }

        const hasCSS = getNodeComponentAttributeValue(node,componentAttributeTypes.customCSS,"")!="";
        const isAbs = getNodeRootStyleAttributeValue(node,designer.state.screenSize,attributeTypes.position,"")=="absolute";


        return<div className='tab-links hierarchy-browser-section'>
                {
                   !isRoot &&
                <div className={'flex-row gap-med tab-link align-center '+CSSClassNames.overrideHover} style={{paddingLeft:((16*(depth-1)))+"px",position:"relative",fontSize:"14px"}}
                    
                    onMouseOver={() => designer.hoverById(node.id)}
                    onContextMenu={(e)=>{
                      
                        let x = e.clientX;
                        if(x>window.innerWidth-260)
                            x = window.innerWidth-260;
                        let y = e.clientY;
                        designer.openContextMenu(x,y,node);
                        e.preventDefault();
                        e.stopPropagation();

                    }


                    }

                    onClick={() => {

                        let parent:LayoutNode|null = node;
                        let sec:LayoutNode|null = null;
                        while(parent && parent.typename != wBComponentTypeNames.pageRoot && parent.typename != wBComponentTypeNames.footer && parent.typename != wBComponentTypeNames.navigationBar){
                            
                            if(parent.typename == wBComponentTypeNames.section){
                                sec = parent;
                            }
                            parent = parent.parent;

                        }

                        if(parent&&parent.typename != wBComponentTypeNames.pageRoot){ // footer header

                            setNodeComponentAttributeValue(parent,componentAttributeTypes.locked,"false");
                            if(parent.forceUpdate)
                                parent.forceUpdate();
                        }


                  
                     
                 
                        
                        if(sec&&!sec.inView&&(window as any).optimizevrendering){
                            
                            setTimeout(()=>{
                            if(!sec)
                                return;
                            let dom = document.getElementById(sec.id);
                            sec.inView = true;
                            let canv = (window as any).canvasRef;
                            if(canv){
                                canv.forceUpdate();
                            }
                            if(dom){
                      
                                dom.scrollIntoView({behavior:"smooth",block:"center"});
                            }
                            },0);

                            setTimeout(()=>{
                                designer.selectElementByLayoutObj(node);
                                if(node.forceUpdate)
                                node.forceUpdate();
                               let dom = document.getElementById(node.id);
                                if(dom){
                                    dom.scrollIntoView({behavior:"smooth",block:"center"});
    
                                }
                            },20);
                            
                        }
                        else{
                       
                        setTimeout(()=>{
                            
                            designer.selectElementByLayoutObj(node)
                        
                            if(node.forceUpdate)
                            node.forceUpdate();
                            let dom = document.getElementById(node.id);
                            if(dom){
                                dom.scrollIntoView({behavior:"smooth",block:"center"});

                            }
                        
                        },50);
                    }
                    
                    }}
                    onMouseEnter={() => designer.hoverById(node.id)}
                >
                
                    {depth==1?<ListDot/>:<NestedBox/>}
                    <div className='center-all' style={{width:"1em"}}>{comp.icon}</div>
                    <div>{name}</div>
                  
                    {isAbs&&<AbsoluteIcon/>}
                    {hasCSS&&<CSSIcon/>}

                </div>
                }
                {
                    node.children.map((child:LayoutNode,index:number)=>{

                        return <RenderNodeRecursive node={child} key={child.id} depth={depth + 1} />

                    })
                }
            
            </div>

    }


    return (
        <div className='hierarchy-browser'>
            <h2 className='panel-heading' >Page Layout</h2>
            <hr/>
            { rootNode.children.length>0&& <RenderNodeRecursive node={rootNode} depth={0} />}
        </div>
    )
}

function ListDot(){

    return <div style={{width:".25em"}}></div>
    // return <svg xmlns="http://www.w3.org/2000/svg" height=".5em" viewBox="0 0 512 512" fill="#ddd"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"/></svg>
}

function NestedBox(){


    return <svg  xmlns="http://www.w3.org/2000/svg" height=".75em" width=".75em" viewBox="0 0 100 100" fill="#ddd" style={{marginTop:"-10px"}}><path d="M0 0 L0 100 L10 100  L 10 0  M0 100 L100 100 L100 90 L0 90Z"/></svg>

}

function AbsoluteIcon(){

    return <div className='font-small' style={{marginTop:"-2px"}}> <HoverToolTip text='This component is positioned absolutely'/><svg xmlns="http://www.w3.org/2000/svg" fill="#2479c7" height="1em" viewBox="0 0 512 512"><path d="M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v96H128V192c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V288h96v96H192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H288V288h96v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H288V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"/></svg></div>
}

function CSSIcon(){

    return <div style={{fontWeight:"bold",letterSpacing:"0",fontSize:"12px",fontStyle:"italic",color:"#2479c7"}}><HoverToolTip text='This component has custom CSS'/>CSS</div>

}